/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import axios from "axios";

export class NetworkOps {
  _httpClient;

  authToken = null;

  contentType = null;

  /**
   * Creates an instance of NetworkOps.
   * It has capabilities to add bearer token
   * @param {options} options axios options
   */
  constructor(options = {}) {
    this._httpClient = axios.create({
      ...options
    });

    this._httpClient.interceptors.request.use(this._addHeaders);
  }

  isStr(str) {
    return typeof str === "string";
  }

  encode(str = "") {
    if (!this.isStr(str)) {
      throw new Error("Please provide string to encode.");
    }

    return encodeURIComponent(str);
    // .replace(/!/g, "%21")
    // .replace(/'/g, "%27")
    // .replace(/\(/g, "%28")
    // .replace(/\)/g, "%29")
    // .replace(/\*/g, "%2A")
    // .replace(/%20/g, "+");
  }

  decode(str = "") {
    if (!this.isStr(str)) {
      throw new Error("Please provide string to decode");
    }

    return decodeURIComponent(str.replace(/%2B/g, "%20"));
  }

  _addHeaders = (request) => {
    if (this.authToken) {
      request.headers.Authorization = `Basic ${this.authToken}`;
    }
    // if (this.userId) {
    //   request.headers["x-prsn-user-id"] = this.userId;
    // }
    if (this.contentType) {
      request.headers["content-type"] = this.contentType;
    }
    return request;
  };

  setAuthTokenSupport = (token) => {
    this.authToken = token;
  };

  setUserId = (id) => {
    this.userId = id;
  };

  clearUserId = () => {
    this.userId = null;
  };

  //   setAuthToken = (token) => {
  //     this.authToken = token;
  //   };

  clearAuthToken = () => {
    this.authToken = null;
  };

  setContentType = (type) => {
    this.contentType = type;
  };

  setResponseInterceptor = (success, error) => {
    this._httpClient.interceptors.response.use(success, error);
  };

  _makeRequest = (method, url, queryParams, body, options = {}) => {
    let request;

    return new Promise((resolve, reject) => {
      switch (method) {
        case "GET":
          request = this._httpClient.get(url, {
            ...options,
            params: queryParams
          });
          break;
        case "POST":
          request = this._httpClient.post(url, body, {
            ...options,
            params: queryParams
          });
          break;
        case "PUT":
          request = this._httpClient.put(url, body, {
            ...options,
            params: queryParams
          });
          break;
        case "PATCH":
          request = this._httpClient.patch(url, body, {
            ...options,
            params: queryParams
          });
          break;
        case "DELETE":
          request = this._httpClient.delete(url, {
            ...options,
            params: queryParams,
            data: body
          });
          break;

        default:
          reject(new Error("Method not supported"));
          return;
      }

      request.then(
        (result) => {
          resolve(result);
        },
        (error) => {
          console.log("Network Error", error.response);
          reject(error.response);
        }
      );
    });
  };

  get = (url, queryParams, options = {}) => {
    return this._makeRequest("GET", url, queryParams, options);
  };

  post = (url, body, queryParams, options = {}) => {
    return this._makeRequest("POST", url, queryParams, body, options);
  };

  put = (url, body, queryParams, options = {}) => {
    return this._makeRequest("PUT", url, queryParams, body, options);
  };

  patch = (url, body, queryParams, options = {}) => {
    return this._makeRequest("PATCH", url, queryParams, body, options);
  };

  delete = (url, body, queryParams, options = {}) => {
    return this._makeRequest("DELETE", url, queryParams, body, options);
  };
}